/**
 * SectionDivider - Simple non-collapsible section header
 *
 * Replaces FieldGroup for compact layouts where all fields should be visible.
 */

import React from 'react';

/**
 * SectionDivider Component
 *
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {React.ReactNode} props.children - Section content
 * @param {string} [props.className] - Additional classes
 */
export default function SectionDivider({
  title,
  children,
  className = '',
}) {
  return (
    <div className={`pt-2 mt-2 border-t border-gray-200 ${className}`}>
      <h5 className="text-[10px] font-medium text-gray-400 uppercase tracking-wider mb-1.5">
        {title}
      </h5>
      <div className="space-y-1">
        {children}
      </div>
    </div>
  );
}
